<template>
  <div class="wrap">
    <div class="group" v-if="all.numone">
      <div class="title border-bottom">获取元积分</div>
      <div class="list">
        <div class="item border-bottom" v-for="(item,index) in all.numone" :key="index" v-if="item.memo">
          <div class="left">
            <div class="name">{{item.name}}</div>
            <div class="detail">{{item.memo}}</div>
          </div>
          <div class="right" v-if="item.total_consume">
            <div class="process"><span class="now">{{item.already_consume||0}}</span>/<span class="all">{{item.total_consume}}</span></div>
          </div>
        </div>
      </div>
    </div>
    <div class="group" v-if="all.numtwo">
      <div class="title border-bottom">golo维修课堂</div>
      <div class="list">
        <div class="item border-bottom" v-for="(item,index) in all.numtwo" :key="index" v-if="item.memo">
          <div class="left">
            <div class="name">{{item.name}}</div>
            <div class="detail">{{item.memo}}</div>
          </div>
          <div class="right" v-if="item.total_consume">
            <div class="process"><span class="now">{{item.already_consume||0}}</span>/<span class="all">{{item.total_consume}}</span></div>
          </div>
        </div>
      </div>
    </div>
    <div class="group" v-if="all.numthree">
      <div class="title border-bottom">golo社区</div>
      <div class="list">
        <div class="item border-bottom" v-for="(item,index) in all.numthree" :key="index" v-if="item.memo">
          <div class="left">
            <div class="name">{{item.name}}</div>
            <div class="detail">{{item.memo}}</div>
          </div>
          <div class="right" v-if="item.total_consume">
            <div class="process"><span class="now">{{item.already_consume||0}}</span>/<span class="all">{{item.total_consume}}</span></div>
          </div>
        </div>
      </div>
    </div>
    <!-- 加载 -->
    <loading v-show="!loaded"></loading>
  </div>
</template>

<script>
import {RES_OK} from '@/api/config'
import {getRule} from '@/api/integral'
import Loading from 'components/base/loading/loading.vue'
export default {
  data() {
    return {
      loaded: false,
      all: {}
    }
  },
  created() {
    getRule().then(({data}) => {
      if (data && data.code === RES_OK) {
        this.all = data.data
      }
      this.loaded = true
    })
  },
  components: {
    Loading
  }
}
</script>

<style scoped lang="stylus" ref="stylesheet/stylus">
  @import "~common/stylus/variable"
  .wrap
    min-height 100vh
    background #ededed
  .group
    background #ffffff
    font-size size(28)
    margin-bottom size(20)
    .title
      color #8e8e8e
      padding 0 size(30)
      line-height size(84)
    .list
      padding-left size(30)
      .item
        display flex
        align-items center
        min-height size(120)
        padding size(20) 0
        padding-right size(16)
        &:before
          background #f5f5f5
    .left
      flex 1
    .name
      color #343434
    .detail
      color #9b9b9b
      font-size size(24)
      line-height 1.4
      margin-top size(14)
    .process
      margin-left 10px
      padding 0 size(24)
      min-width size(110)
      line-height size(64)
      border-radius 5px
      background #f9f8f8
      text-align center
      color #b9b9b9
      font-size size(28)
      .now
        color #7a7a7a
</style>


// WEBPACK FOOTER //
// src/components/personal/integral/rule.vue